<template>
	<div class="row d-flex justify-content-center">
		<div class="col-12 table-wrapper-list" v-if="list.length > 0">
			<table class="table table-striped" >
				<thead>
					<tr>
						<td>Ügyfél</td>
						<td>Régió</td>
						<td>Becsült szállítás</td>
						<td>Termék</td>
						<td>Darabszám</td>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(v,k) in list"
						:key="`list-${k}`"
					>
						<td>
							{{ v.nev }}
						</td>
						<td>
							{{ v.regio }}
						</td>
						<td>
							{{ v.kidatum }}
						</td>
						<td>
							{{ v.termek }}
						</td>
						<td>
							{{ v.db }}{{ v.tszam == 2 ? ' x 6' : '' }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="col-12 col-md-8 col-lg-6 alert alert-info text-center" v-else>
			<p class="h4">
				Nincs jóváhagyásra váró webes rendelés
			</p>
		</div>
	</div>
</template>
<script type="text/javascript">
export default {
	props: ['list']
}
</script>


// WEBPACK FOOTER //
// src/components/webOrders/list.vue